import { Box, Button, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WTypography from 'Components/whiteTypography'
import { Bar } from 'react-chartjs-2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import TauxImposition from './TauxImposition'
import EmptyCardState from './EmptyCardState'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function MonBudget({ oldData, updateReports }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [tauxImOpen, setTauxImOpen] = useState(false)
  const navigate = useNavigate()

  // Carte vide : aucune donnée de budget (ni dépense, ni impôt, ni cashflow).
  const hasBudgetData = Boolean(
    oldData && (oldData.depense || oldData.impots || oldData.cashflow),
  )

  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    aspectRatio: 1,

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'right',
        labels: {
          boxWidth: 10,
          color: 'white',
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
          title: () => null,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: 'white' },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }
  const color = [
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
    '#95bee5',
    '#67a7e3',
    '#4498e7',
    '#1c86e9',
    '#1263af',
    '#08447d',
  ]
  const [data, setRevData] = useState({
    labels: [''],
    datasets: [
      {
        label: t('monPatrimoine.taxes'), // LAP-733 (GE022)
        data: [oldData?.impots],
        backgroundColor: ['#195b93'],
        borderColor: ['#195b93'],
        // barThickness: 10,
      },
      {
        label: t('monPatrimoine.expenses'),
        data: [oldData?.depense],
        backgroundColor: ['#7ab1df'],
        borderColor: ['#7ab1df'],
        // barThickness: 10,
      },
      {
        label: t('monPatrimoine.cashflow'),
        data: [oldData?.cashflow],
        backgroundColor: ['#dae8f3'],
        borderColor: ['#dae8f3'],
        // barThickness: 10,
      },
    ],
  })

  useEffect(() => {
    let dataset = []
    let check = false
    if (oldData?.depense) {
      check = true
      dataset.push({
        label: t('monPatrimoine.expenses'), // LAP-733 (GE022)
        data: [oldData?.depense],
        backgroundColor: ['#7ab1df'],
        borderColor: ['#7ab1df'],
        // barThickness: 10,
      })
    }
    if (oldData?.impots) {
      check = true
      dataset.push({
        label: t('monPatrimoine.taxes'),
        data: [oldData?.impots],
        backgroundColor: ['#195b93'],
        borderColor: ['#195b93'],
        // barThickness: 10,
      })
    }
    if (check) {
      dataset.push({
        label: t('monPatrimoine.cashflow'),
        data: [oldData?.cashflow],
        backgroundColor: ['#dae8f3'],
        borderColor: ['#dae8f3'],
        // barThickness: 10,
      })
    }
    setRevData({
      labels: [''],
      datasets: dataset,
    })
    // LAP-733 (GE022) — refresh dataset labels on locale switch
  }, [oldData, i18n.language])

  const VerticalBarChart = () => (
    <>
      <Bar data={data} height={560} options={optionsbar} />
    </>
  )
  return (
    <>
      {tauxImOpen && <TauxImposition updateReports={updateReports} setTauxImOpen={setTauxImOpen} />}
      <Card className="dashboard_card__root1">
        {/* Header cliquable → application Mon Budget */}
        <Box
          className="dashboard_card__header1 no-drag"
          onClick={() => navigate('/Monbudget')}
          sx={{ cursor: 'pointer' }}
        >
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.myBudget')}
          </WTypography>
          {hasBudgetData && (
            <WTypography component={'span'} variant="h6">
              {parseInt(oldData?.avarage_income).toFixed(0)}
              <WTypography
                component={'span'}
                sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
              >
                €
              </WTypography>
            </WTypography>
          )}
        </Box>

        {hasBudgetData ? (
          <>
            <Box className="dashboard_card__header1">
              <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
                {t('monPatrimoine.budgetOnMonthlyIncome')}
              </WTypography>
            </Box>

            {/* LAP-PAT1 — capacité d'épargne observée (12 mois révolus) */}
            {oldData?.capacite_epargne?.monthly_average != null && (
              <Box
                sx={{
                  mx: 1,
                  mt: 1,
                  px: 1.5,
                  py: 0.75,
                  borderRadius: '8px',
                  border: '1px solid #ffffff22',
                  backgroundColor: '#ffffff0d',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <WTypography sx={{ color: '#ffffffa1', fontSize: '12px' }}>
                  {t('monPatrimoine.savingsCapacity')}
                </WTypography>
                <WTypography
                  sx={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color:
                      oldData.capacite_epargne.monthly_average >= 0 ? '#8be28b' : '#ff9c9c',
                  }}
                >
                  {Number(oldData.capacite_epargne.monthly_average).toLocaleString('fr-FR')} €/
                  {t('monPatrimoine.perMonth')}
                </WTypography>
              </Box>
            )}

            <Box minWidth={3} mb={6} height={'100%'}>
              <VerticalBarChart />
            </Box>
            <Box
              mt={2}
              pb={1}
              sx={{ right: 'unset !important' }}
              className="dashboard_card__filters1"
            >
              <Box
                sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                className="no-drag"
              >
                <Button
                  onClick={() => setTauxImOpen(true)}
                  startIcon={<FontAwesomeIcon icon={faInfo} />}
                  sx={{
                    mr: 1,
                    minWidth: '23px',
                    minHeight: '21px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    '& .MuiButton-startIcon': { margin: 0, '& svg': { fontSize: '12px' } },
                    '&:hover': { backgroundColor: 'white !important' },
                  }}
                ></Button>
                <WTypography sx={{ color: 'white' }} variant={'body2'}>
                  {t('monPatrimoine.budgetOnMonthlyIncome')}{' '}
                  {parseInt(oldData?.last_tax_rate).toFixed(0)}%
                </WTypography>
              </Box>
            </Box>
          </>
        ) : (
          <EmptyCardState
            icon={<AccountBalanceWalletIcon />}
            title={t('monPatrimoine.budgetEmptyTitle')}
            description={t('monPatrimoine.budgetEmptyDesc')}
            ctaLabel={t('monPatrimoine.budgetEmptyCta')}
            onCta={() => navigate('/Monbudget')}
          />
        )}
      </Card>
    </>
  )
}

export default MonBudget
